module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2012-08-10",
		"endpointPrefix": "dynamodb",
		"jsonVersion": "1.0",
		"protocol": "json",
		"serviceAbbreviation": "DynamoDB",
		"serviceFullName": "Amazon DynamoDB",
		"signatureVersion": "v4",
		"targetPrefix": "DynamoDB_20120810",
		"uid": "dynamodb-2012-08-10"
	},
	"operations": {
		"BatchGetItem": {
			"input": {
				"type": "structure",
				"required": [
					"RequestItems"
				],
				"members": {
					"RequestItems": {
						"shape": "S2"
					},
					"ReturnConsumedCapacity": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Responses": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "Sr"
						}
					},
					"UnprocessedKeys": {
						"shape": "S2"
					},
					"ConsumedCapacity": {
						"shape": "St"
					}
				}
			}
		},
		"BatchWriteItem": {
			"input": {
				"type": "structure",
				"required": [
					"RequestItems"
				],
				"members": {
					"RequestItems": {
						"shape": "S10"
					},
					"ReturnConsumedCapacity": {},
					"ReturnItemCollectionMetrics": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UnprocessedItems": {
						"shape": "S10"
					},
					"ItemCollectionMetrics": {
						"type": "map",
						"key": {},
						"value": {
							"type": "list",
							"member": {
								"shape": "S1a"
							}
						}
					},
					"ConsumedCapacity": {
						"shape": "St"
					}
				}
			}
		},
		"CreateTable": {
			"input": {
				"type": "structure",
				"required": [
					"AttributeDefinitions",
					"TableName",
					"KeySchema",
					"ProvisionedThroughput"
				],
				"members": {
					"AttributeDefinitions": {
						"shape": "S1f"
					},
					"TableName": {},
					"KeySchema": {
						"shape": "S1j"
					},
					"LocalSecondaryIndexes": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"IndexName",
								"KeySchema",
								"Projection"
							],
							"members": {
								"IndexName": {},
								"KeySchema": {
									"shape": "S1j"
								},
								"Projection": {
									"shape": "S1o"
								}
							}
						}
					},
					"GlobalSecondaryIndexes": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"IndexName",
								"KeySchema",
								"Projection",
								"ProvisionedThroughput"
							],
							"members": {
								"IndexName": {},
								"KeySchema": {
									"shape": "S1j"
								},
								"Projection": {
									"shape": "S1o"
								},
								"ProvisionedThroughput": {
									"shape": "S1u"
								}
							}
						}
					},
					"ProvisionedThroughput": {
						"shape": "S1u"
					},
					"StreamSpecification": {
						"shape": "S1w"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TableDescription": {
						"shape": "S20"
					}
				}
			}
		},
		"DeleteItem": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"Key"
				],
				"members": {
					"TableName": {},
					"Key": {
						"shape": "S6"
					},
					"Expected": {
						"shape": "S2e"
					},
					"ConditionalOperator": {},
					"ReturnValues": {},
					"ReturnConsumedCapacity": {},
					"ReturnItemCollectionMetrics": {},
					"ConditionExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					},
					"ExpressionAttributeValues": {
						"shape": "S2m"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "Ss"
					},
					"ConsumedCapacity": {
						"shape": "Su"
					},
					"ItemCollectionMetrics": {
						"shape": "S1a"
					}
				}
			}
		},
		"DeleteTable": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"TableName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TableDescription": {
						"shape": "S20"
					}
				}
			}
		},
		"DescribeLimits": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"members": {
					"AccountMaxReadCapacityUnits": {
						"type": "long"
					},
					"AccountMaxWriteCapacityUnits": {
						"type": "long"
					},
					"TableMaxReadCapacityUnits": {
						"type": "long"
					},
					"TableMaxWriteCapacityUnits": {
						"type": "long"
					}
				}
			}
		},
		"DescribeTable": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"TableName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Table": {
						"shape": "S20"
					}
				}
			}
		},
		"DescribeTimeToLive": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"TableName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TimeToLiveDescription": {
						"type": "structure",
						"members": {
							"TimeToLiveStatus": {},
							"AttributeName": {}
						}
					}
				}
			}
		},
		"GetItem": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"Key"
				],
				"members": {
					"TableName": {},
					"Key": {
						"shape": "S6"
					},
					"AttributesToGet": {
						"shape": "Sj"
					},
					"ConsistentRead": {
						"type": "boolean"
					},
					"ReturnConsumedCapacity": {},
					"ProjectionExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Item": {
						"shape": "Ss"
					},
					"ConsumedCapacity": {
						"shape": "Su"
					}
				}
			}
		},
		"ListTables": {
			"input": {
				"type": "structure",
				"members": {
					"ExclusiveStartTableName": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TableNames": {
						"type": "list",
						"member": {}
					},
					"LastEvaluatedTableName": {}
				}
			}
		},
		"ListTagsOfResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArn"
				],
				"members": {
					"ResourceArn": {},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Tags": {
						"shape": "S3a"
					},
					"NextToken": {}
				}
			}
		},
		"PutItem": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"Item"
				],
				"members": {
					"TableName": {},
					"Item": {
						"shape": "S14"
					},
					"Expected": {
						"shape": "S2e"
					},
					"ReturnValues": {},
					"ReturnConsumedCapacity": {},
					"ReturnItemCollectionMetrics": {},
					"ConditionalOperator": {},
					"ConditionExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					},
					"ExpressionAttributeValues": {
						"shape": "S2m"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "Ss"
					},
					"ConsumedCapacity": {
						"shape": "Su"
					},
					"ItemCollectionMetrics": {
						"shape": "S1a"
					}
				}
			}
		},
		"Query": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"TableName": {},
					"IndexName": {},
					"Select": {},
					"AttributesToGet": {
						"shape": "Sj"
					},
					"Limit": {
						"type": "integer"
					},
					"ConsistentRead": {
						"type": "boolean"
					},
					"KeyConditions": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S3k"
						}
					},
					"QueryFilter": {
						"shape": "S3l"
					},
					"ConditionalOperator": {},
					"ScanIndexForward": {
						"type": "boolean"
					},
					"ExclusiveStartKey": {
						"shape": "S6"
					},
					"ReturnConsumedCapacity": {},
					"ProjectionExpression": {},
					"FilterExpression": {},
					"KeyConditionExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					},
					"ExpressionAttributeValues": {
						"shape": "S2m"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Items": {
						"shape": "Sr"
					},
					"Count": {
						"type": "integer"
					},
					"ScannedCount": {
						"type": "integer"
					},
					"LastEvaluatedKey": {
						"shape": "S6"
					},
					"ConsumedCapacity": {
						"shape": "Su"
					}
				}
			}
		},
		"Scan": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"TableName": {},
					"IndexName": {},
					"AttributesToGet": {
						"shape": "Sj"
					},
					"Limit": {
						"type": "integer"
					},
					"Select": {},
					"ScanFilter": {
						"shape": "S3l"
					},
					"ConditionalOperator": {},
					"ExclusiveStartKey": {
						"shape": "S6"
					},
					"ReturnConsumedCapacity": {},
					"TotalSegments": {
						"type": "integer"
					},
					"Segment": {
						"type": "integer"
					},
					"ProjectionExpression": {},
					"FilterExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					},
					"ExpressionAttributeValues": {
						"shape": "S2m"
					},
					"ConsistentRead": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Items": {
						"shape": "Sr"
					},
					"Count": {
						"type": "integer"
					},
					"ScannedCount": {
						"type": "integer"
					},
					"LastEvaluatedKey": {
						"shape": "S6"
					},
					"ConsumedCapacity": {
						"shape": "Su"
					}
				}
			}
		},
		"TagResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArn",
					"Tags"
				],
				"members": {
					"ResourceArn": {},
					"Tags": {
						"shape": "S3a"
					}
				}
			}
		},
		"UntagResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArn",
					"TagKeys"
				],
				"members": {
					"ResourceArn": {},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"UpdateItem": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"Key"
				],
				"members": {
					"TableName": {},
					"Key": {
						"shape": "S6"
					},
					"AttributeUpdates": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"members": {
								"Value": {
									"shape": "S8"
								},
								"Action": {}
							}
						}
					},
					"Expected": {
						"shape": "S2e"
					},
					"ConditionalOperator": {},
					"ReturnValues": {},
					"ReturnConsumedCapacity": {},
					"ReturnItemCollectionMetrics": {},
					"UpdateExpression": {},
					"ConditionExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					},
					"ExpressionAttributeValues": {
						"shape": "S2m"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "Ss"
					},
					"ConsumedCapacity": {
						"shape": "Su"
					},
					"ItemCollectionMetrics": {
						"shape": "S1a"
					}
				}
			}
		},
		"UpdateTable": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"AttributeDefinitions": {
						"shape": "S1f"
					},
					"TableName": {},
					"ProvisionedThroughput": {
						"shape": "S1u"
					},
					"GlobalSecondaryIndexUpdates": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Update": {
									"type": "structure",
									"required": [
										"IndexName",
										"ProvisionedThroughput"
									],
									"members": {
										"IndexName": {},
										"ProvisionedThroughput": {
											"shape": "S1u"
										}
									}
								},
								"Create": {
									"type": "structure",
									"required": [
										"IndexName",
										"KeySchema",
										"Projection",
										"ProvisionedThroughput"
									],
									"members": {
										"IndexName": {},
										"KeySchema": {
											"shape": "S1j"
										},
										"Projection": {
											"shape": "S1o"
										},
										"ProvisionedThroughput": {
											"shape": "S1u"
										}
									}
								},
								"Delete": {
									"type": "structure",
									"required": [
										"IndexName"
									],
									"members": {
										"IndexName": {}
									}
								}
							}
						}
					},
					"StreamSpecification": {
						"shape": "S1w"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TableDescription": {
						"shape": "S20"
					}
				}
			}
		},
		"UpdateTimeToLive": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"TimeToLiveSpecification"
				],
				"members": {
					"TableName": {},
					"TimeToLiveSpecification": {
						"shape": "S4a"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TimeToLiveSpecification": {
						"shape": "S4a"
					}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "map",
			"key": {},
			"value": {
				"type": "structure",
				"required": [
					"Keys"
				],
				"members": {
					"Keys": {
						"type": "list",
						"member": {
							"shape": "S6"
						}
					},
					"AttributesToGet": {
						"shape": "Sj"
					},
					"ConsistentRead": {
						"type": "boolean"
					},
					"ProjectionExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					}
				}
			}
		},
		"S6": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S8"
			}
		},
		"S8": {
			"type": "structure",
			"members": {
				"S": {},
				"N": {},
				"B": {
					"type": "blob"
				},
				"SS": {
					"type": "list",
					"member": {}
				},
				"NS": {
					"type": "list",
					"member": {}
				},
				"BS": {
					"type": "list",
					"member": {
						"type": "blob"
					}
				},
				"M": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S8"
					}
				},
				"L": {
					"type": "list",
					"member": {
						"shape": "S8"
					}
				},
				"NULL": {
					"type": "boolean"
				},
				"BOOL": {
					"type": "boolean"
				}
			}
		},
		"Sj": {
			"type": "list",
			"member": {}
		},
		"Sm": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"Sr": {
			"type": "list",
			"member": {
				"shape": "Ss"
			}
		},
		"Ss": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S8"
			}
		},
		"St": {
			"type": "list",
			"member": {
				"shape": "Su"
			}
		},
		"Su": {
			"type": "structure",
			"members": {
				"TableName": {},
				"CapacityUnits": {
					"type": "double"
				},
				"Table": {
					"shape": "Sw"
				},
				"LocalSecondaryIndexes": {
					"shape": "Sx"
				},
				"GlobalSecondaryIndexes": {
					"shape": "Sx"
				}
			}
		},
		"Sw": {
			"type": "structure",
			"members": {
				"CapacityUnits": {
					"type": "double"
				}
			}
		},
		"Sx": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "Sw"
			}
		},
		"S10": {
			"type": "map",
			"key": {},
			"value": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"PutRequest": {
							"type": "structure",
							"required": [
								"Item"
							],
							"members": {
								"Item": {
									"shape": "S14"
								}
							}
						},
						"DeleteRequest": {
							"type": "structure",
							"required": [
								"Key"
							],
							"members": {
								"Key": {
									"shape": "S6"
								}
							}
						}
					}
				}
			}
		},
		"S14": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S8"
			}
		},
		"S1a": {
			"type": "structure",
			"members": {
				"ItemCollectionKey": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S8"
					}
				},
				"SizeEstimateRangeGB": {
					"type": "list",
					"member": {
						"type": "double"
					}
				}
			}
		},
		"S1f": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"AttributeName",
					"AttributeType"
				],
				"members": {
					"AttributeName": {},
					"AttributeType": {}
				}
			}
		},
		"S1j": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"AttributeName",
					"KeyType"
				],
				"members": {
					"AttributeName": {},
					"KeyType": {}
				}
			}
		},
		"S1o": {
			"type": "structure",
			"members": {
				"ProjectionType": {},
				"NonKeyAttributes": {
					"type": "list",
					"member": {}
				}
			}
		},
		"S1u": {
			"type": "structure",
			"required": [
				"ReadCapacityUnits",
				"WriteCapacityUnits"
			],
			"members": {
				"ReadCapacityUnits": {
					"type": "long"
				},
				"WriteCapacityUnits": {
					"type": "long"
				}
			}
		},
		"S1w": {
			"type": "structure",
			"members": {
				"StreamEnabled": {
					"type": "boolean"
				},
				"StreamViewType": {}
			}
		},
		"S20": {
			"type": "structure",
			"members": {
				"AttributeDefinitions": {
					"shape": "S1f"
				},
				"TableName": {},
				"KeySchema": {
					"shape": "S1j"
				},
				"TableStatus": {},
				"CreationDateTime": {
					"type": "timestamp"
				},
				"ProvisionedThroughput": {
					"shape": "S23"
				},
				"TableSizeBytes": {
					"type": "long"
				},
				"ItemCount": {
					"type": "long"
				},
				"TableArn": {},
				"LocalSecondaryIndexes": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"IndexName": {},
							"KeySchema": {
								"shape": "S1j"
							},
							"Projection": {
								"shape": "S1o"
							},
							"IndexSizeBytes": {
								"type": "long"
							},
							"ItemCount": {
								"type": "long"
							},
							"IndexArn": {}
						}
					}
				},
				"GlobalSecondaryIndexes": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"IndexName": {},
							"KeySchema": {
								"shape": "S1j"
							},
							"Projection": {
								"shape": "S1o"
							},
							"IndexStatus": {},
							"Backfilling": {
								"type": "boolean"
							},
							"ProvisionedThroughput": {
								"shape": "S23"
							},
							"IndexSizeBytes": {
								"type": "long"
							},
							"ItemCount": {
								"type": "long"
							},
							"IndexArn": {}
						}
					}
				},
				"StreamSpecification": {
					"shape": "S1w"
				},
				"LatestStreamLabel": {},
				"LatestStreamArn": {}
			}
		},
		"S23": {
			"type": "structure",
			"members": {
				"LastIncreaseDateTime": {
					"type": "timestamp"
				},
				"LastDecreaseDateTime": {
					"type": "timestamp"
				},
				"NumberOfDecreasesToday": {
					"type": "long"
				},
				"ReadCapacityUnits": {
					"type": "long"
				},
				"WriteCapacityUnits": {
					"type": "long"
				}
			}
		},
		"S2e": {
			"type": "map",
			"key": {},
			"value": {
				"type": "structure",
				"members": {
					"Value": {
						"shape": "S8"
					},
					"Exists": {
						"type": "boolean"
					},
					"ComparisonOperator": {},
					"AttributeValueList": {
						"shape": "S2i"
					}
				}
			}
		},
		"S2i": {
			"type": "list",
			"member": {
				"shape": "S8"
			}
		},
		"S2m": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S8"
			}
		},
		"S3a": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S3k": {
			"type": "structure",
			"required": [
				"ComparisonOperator"
			],
			"members": {
				"AttributeValueList": {
					"shape": "S2i"
				},
				"ComparisonOperator": {}
			}
		},
		"S3l": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S3k"
			}
		},
		"S4a": {
			"type": "structure",
			"required": [
				"Enabled",
				"AttributeName"
			],
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"AttributeName": {}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/dynamodb-2012-08-10.min.json
// module id = 388
// module chunks = 0